<template>
  <div>
    <top-bar @changeEmpresa="changeEmpresa()"/>
    <div class="content">
      <div class="container-fluid">
        <loading v-show="load"/>
        <div v-show="!load">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h1 class="h3 mb-0 text-gray-800">Configurações</h1>
            <div :class="{'invisible':menu !== 1}">
              <button class="btn btn-danger px-4" @click="enviarDados()">Salvar</button>
            </div>
          </div>
          <modal-menu :menus="menus" :selected="menu" @changeMenu="changeMenu"/>

          <div class="row" v-show="menu === 1">
            <div class="col-md-7">
              <div class="card shadow-sm mb-4 mb-md-0">
                <div class="card-body text-md-left py-4">
                  <div class="row">
                    <div class="col-md-4 mb-2">
                      <label class="mb-0" for="nome"><b>Nome do Bot</b></label>
                      <input type="text" id="nome" class="form-control" placeholder="De um nome ao Bot" v-model="dados.nome_bot">
                    </div>
                    <div class="col-md-4 mb-2">
                      <label class="mb-0" for="icone"><b>Ícone do Bot</b></label>
                      <select id="icone" class="form-control" v-model="dados.icon_bot">
                        <option value="🤖">🤖 (Robo)</option>
                        <option value="🐝">🐝 (Abelha)</option>
                        <option value="🥰">🥰 (Apaixonado)</option>
                        <option value="👨‍💻">👨‍💻 (Atendente Homem)</option>
                        <option value="👩‍💻">👩‍💻 (Atendente Mulher)</option>
                        <option value="🐳">🐳 (Baleia)</option>
                        <option value="🎂">🎂 (Bolo)</option>
                        <option value="🍔">🍔 (Burger)</option>
                        <option value="🐶">🐶 (Cachorro)</option>
                        <option value="✅">✅ (Check)</option>
                        <option value="👨‍🍳">👨‍🍳 (Chef Homem)</option>
                        <option value="👩‍🍳">👩‍🍳 (Chef Mulher)</option>
                        <option value="🍺">🍺 (Chopp)</option>
                        <option value="🤠‍">🤠‍️ (Cowboy)</option>
                        <option value="🐰">🐰 (Coelho)</option>
                        <option value="👑">👑 (Coroa)</option>
                        <option value="🦖">🦖 (Dinossauro)</option>
                        <option value="🐔">🐔 (Galinha)</option>
                        <option value="🐱">🐱 (Gato)</option>
                        <option value="👨‍🎤">👨‍🎤 (Gótico)</option>
                        <option value="🌭">🌭 (Hot-Dog)</option>
                        <option value="😎">😎 (Irado)</option>
                        <option value="🦁">🦁 (Leão)</option>
                        <option value="🤓">🤓 (Nerd)</option>
                        <option value="🥷🏼">🥷🏼 (Ninja)</option>
                        <option value="🐟">🐟 (Peixe)</option>
                        <option value="🐧">🐧 (Pinguim)</option>
                        <option value="🍿">🍿 (Pipoca)</option>
                        <option value="🍕">🍕 (Pizza)</option>
                        <option value="🐷">🐷 (Porco)</option>
                        <option value="🪐">🪐 (Planeta)</option>
                        <option value="🦆">🦆 (Pato)</option>
                        <option value="🥗">🥗 (Salada)</option>
                        <option value="🐸">🐸 (Sapo)</option>
                        <option value="🍦">🍦 (Sorvete)</option>
                        <option value="😊">😊 (Smiley)</option>
                        <option value="🍣">🍣 (Sushi)</option>
                        <option value="🦊">🦊 (Raposa)</option>
                        <option value="🦈">🦈 (Tubarão)</option>
                        <option value="🐯">🐯 (Tigre)</option>
                        <option value="🐮">🐮 (Vaca)</option>
                      </select>
                    </div>
                    <div class="col-md-4 mb-2">
                      <label class="mb-0"><b>Fluxo</b></label>
                      <select class="form-control" v-model="dados.id_fluxo">
                        <option value="1">Fluxo Padrão</option>
                        <option value="2">Reservas ou Encomendas</option>
                        <option value="3">Fluxo Simples</option>
                        <option value="4">Fluxo IA (Beta)</option>
                        <option :value="null">Personalizado</option>
                      </select>
                    </div>
                  </div>
                  <hr>
                  <h6 class="font-weight-bold mb-2">Preferências do sistema</h6>
                  <div class="row">
                    <div class="col-md-12 mb-2">
                      <label class="mb-0">
                        <input type="checkbox" @change="dados.recuperador = (dados.recuperador === '1') ? '0' : '1'" :checked="dados.recuperador === '1'">
                        Habilitar o recuperador de vendas
                      </label>
                    </div>
                    <div class="col-md-12 mb-2">
                      <label class="mb-0 mr-1">
                        <input type="checkbox" @change="dados.msg_avaliacao = (dados.msg_avaliacao === '1') ? '0' : '1'" :checked="dados.msg_avaliacao === '1'">
                        Habilitar mensagem de avaliação de pedido
                      </label>
                      <tooltip msg="Não serão enviadas para pedidos finalizados em massa."/>
                    </div>
                    <div class="col-md-12 mb-2">
                      <label class="mb-0">
                        <input type="checkbox" @change="dados.log_error = (dados.log_error === '1') ? '0' : '1'" :checked="dados.log_error === '0'">
                        Pausar o Bot se nenhuma opção for selecionada
                      </label>
                    </div>
                    <div class="col-md-12">
                      <hr>
                      <h6 class="font-weight-bold mb-2">Notificações</h6>
                    </div>
                    <div class="col-md-12 mb-2">
                      <label class="mb-0">
                        <input type="checkbox" @change="dados.lebot_notificacao = (dados.lebot_notificacao === '1') ? '0' : '1'" :checked="dados.lebot_notificacao === '1'">
                        Notificar as alterações de status de pedidos feitos fora do Bot
                        <tooltip msg="Pedido app/site e pedido manual"/>
                      </label>
                    </div>
                    <div class="col-md-12 mb-2" v-if="dados.lebot_notificacao === '1'">
                      <label class="mb-0">
                        <input type="checkbox" v-model="dados.ignora_interacao" true-value="1" false-value="0" @change="toggleConfigAlerta('ignora_interacao')">
                        Enviar mensagens de status do pedido mesmo sem interação do usuário
                      </label>
                    </div>
                    <div class="col-md-12 mb-2">
                      <label class="mb-0">
                        <input type="checkbox" v-model="dados.notifica_mktplace" true-value="1" false-value="0" @change="toggleConfigAlerta('notifica_mktplace')">
                        Notificar as alterações de status de pedidos feitos por marketplaces
                      </label>
                    </div>
                    <div class="col-md-12">
                      <hr>
                      <h6 class="font-weight-bold mb-2">Atendimento</h6>
                      <div>
                        <label class="mb-0">
                          <input type="checkbox" @change="dados.atendimento = (dados.atendimento === '1') ? '0' : '1'" :checked="dados.atendimento === '1'">
                          Habilitar atendimento humano
                        </label>
                        <div class="mb-2" v-if="dados.atendimento === '1'">
                          <div class="mb-2">
                            <label class="small mb-1" for="tempo">Tempo para ser atendido (minutos)</label>
                            <input id="tempo" type="number" class="form-control" placeholder="Ex: 2" v-model="dados.atendimento_tempo" style="max-width: 160px">
                          </div>
                          <div>
                            <label class="mb-0">
                              <input type="checkbox" @change="dados.validar_horario = (dados.validar_horario === '1') ? '0' : '1'" :checked="dados.validar_horario === '0'">
                              Atendimento fora do horario de funcionamento da empresa
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="card shadow-sm mb-4 mb-md-0">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-center">
                    <h6 class="font-weight-bold mb-0">Gerenciar contas</h6>
                    <button class="btn btn-sm btn-primary" @click="modalConta = true"><i class="fa fa-plus mr-1"></i> Adicionar</button>
                  </div>
                  <div class="d-flex justify-content-between align-items-center border-bottom py-2" v-for="e in empresas">
                    <div>
                      <h6 class="m-0">{{e.nome_fantasia}}</h6>
                      <div class="small text-muted">{{e.email}}</div>
                    </div>
                    <div>
                      <button class="btn btn-sm btn-outline-dark" @click="removerEmpresa(e)" v-if="empresas.length > 1"><i class="fa fa-sign-out-alt mr-1"></i> Sair</button>
                    </div>
                  </div>
                  <button class="btn btn-outline-dark mt-3" @click="confirmLogout" style="min-width: 230px"><i class="fa fa-sign-out-alt mr-1"></i> {{empresas.length > 1 ? 'Sair de todas as contas' : 'Sair'}}</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card shadow-sm mb-4 mb-md-0" v-show="menu === 2">
            <div class="card-body">
              <table class="table mb-0">
                <thead>
                <tr>
                  <th>Mensagens</th>
                  <th>&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="p in perguntas">
                  <td class="align-middle pointer" @click="selMensagem(p)">
                    {{p.titulo}}
                    <div class="small">{{p.descricao}}</div>
                  </td>
                  <td class="text-right align-middle">
                    <button class="btn btn-info btn-sm" @click="selMensagem(p)"><i class="fa fa-pencil-alt"></i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-show="menu === 3">
            <div class="row">
              <div class="col-md-3 mb-3">
                <select class="form-control" v-model="id_fluxo" @change="buscarOpcoesBot()">
                  <option value="1">Fluxo Padrão</option>
                  <option value="2">Reservas ou Encomendas</option>
                  <option value="3">Fluxo Simples</option>
                  <option value="4">Fluxo IA (Beta)</option>
                  <option :value="null">Personalizado</option>
                </select>
              </div>
              <div class="col-md-6 mb-3 ml-auto text-right" v-if="opcoes.length && (!id_fluxo || master)">
                <button class="btn btn-outline-info mr-2" @click="selOpcao(null, true)" v-if="id_fluxo !== '1'"><i class="fa fa-sync-alt"></i> Sincronizar</button>
                <button class="btn btn-primary" @click="selOpcao()"><i class="fa fa-plus"></i> Nova Opção</button>
              </div>
            </div>
            <div class="card shadow-sm mb-4 mb-md-0">
              <div class="card-body">
                <table class="table mb-0" v-show="opcoes.length">
                  <thead>
                  <tr>
                    <th>Opções</th>
                    <th>&nbsp;</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="o in opcoes">
                    <td class="align-middle pointer" @click="selOpcao(o.id_opcao)">
                      <b>{{o.step > 0 ? o.step : '#'}} - </b>{{ o.nome_opcao }}
                    </td>
                    <td class="text-right" v-if="!id_fluxo || master">
                      <button class="btn btn-dark btn-sm mr-1" style="width: 32px" @click="removerOpcao(o)" v-if="o.step > 0"><i class="fa fa-trash-alt"></i></button>
                      <button class="btn btn-info btn-sm" @click="selOpcao(o.id_opcao)" style="width: 32px"><i class="fa fa-pencil-alt"></i></button>
                    </td>
                    <td class="text-right" v-else>
                      <button class="btn btn-info btn-sm" @click="selOpcao(o.id_opcao)" style="width: 32px"><i class="fa fa-angle-right"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div class="text-center py-4" v-if="!opcoes.length">
                  <div v-if="!id_fluxo">
                    <h5 class="font-weight-bold mb-1">Fluxo Personalizado</h5>
                    <p>Com o fluxo personalizado você monta a sua própria estrutura de respostas no Bot do LeCard</p>
                  </div>
                  <button class="btn btn-primary" @click="selOpcao()"><i class="fa fa-plus"></i> Novo Fluxo</button>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-show="menu === 4">
            <div class="col-md-8 col-xl-6">
              <div class="card shadow-sm mb-4 mb-md-0" >
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-center">
                    <h6 class="m-0">Servidor Alternativo</h6>
                    <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:" @click="toggleServer()">
                      <span class="small mr-2">{{ modo_alternativo ? 'Ativado' : 'Desativado' }}</span>
                      <img class="switch" src="../assets/icons/switch-on.svg" v-show="modo_alternativo" alt="Ativado"/>
                      <img class="switch" src="../assets/icons/switch-off.svg" v-show="!modo_alternativo" alt="Desativado"/>
                    </a>
                  </div>
                  <div v-if="master">
                    <hr>
                    <div class="d-flex justify-content-between align-items-center">
                      <h6 class="m-0">Modo Teste</h6>
                      <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:" @click="toggleServerTeste()">
                        <span class="small mr-2">{{ modo_teste ? 'Ativado' : 'Desativado' }}</span>
                        <img class="switch" src="../assets/icons/switch-on.svg" v-show="modo_teste" alt="Ativado"/>
                        <img class="switch" src="../assets/icons/switch-off.svg" v-show="!modo_teste" alt="Desativado"/>
                      </a>
                    </div>
                  </div>
                  <div>
                    <hr>
                    <div class="d-flex justify-content-between align-items-center">
                      <h6 class="m-0">Modo Beta</h6>
                      <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:" @click="toggleServerBeta()">
                        <span class="small mr-2">{{ modo_beta ? 'Ativado' : 'Desativado' }}</span>
                        <img class="switch" src="../assets/icons/switch-on.svg" v-show="modo_beta" alt="Ativado"/>
                        <img class="switch" src="../assets/icons/switch-off.svg" v-show="!modo_beta" alt="Desativado"/>
                      </a>
                    </div>
                  </div>
                  <hr>
                  <div>
                    <h6 class="mb-0">Danger zone</h6>
                    <p class="mb-2 small">Limpar todas as configurações salvas</p>
                    <button class="btn btn-danger" @click="resetar" style="width: 200px"><i class="fa fa-exclamation-triangle mr-1"></i> Resetar sistema</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="version text-center">Web: {{ app_version }}<span v-if="isElectron"> - Bot: {{ version }}</span></div>
        </div>
      </div>
    </div>

    <modal :opened="modalMsg" :preview="!dadosMsg" @fechar="modalMsg = false" @salvar="salvarMensagem">
      <loading v-if="loadMsg"/>
      <div v-else-if="dadosMsg">
        <h2 class="font-weight-bold">{{dadosMsg.titulo}}</h2>
        <div class="alert alert-info small"><i class="fa fa-info-circle mr-1"></i> {{dadosMsg.descricao}}</div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="mb-1"><input type="checkbox" class="mr-1" :checked="dadosMsg.fg_ativo === '1'" @change="dadosMsg.fg_ativo = dadosMsg.fg_ativo === '1' ? '2' : '1'">Personalizar resposta</label>
              <div v-if="dadosMsg.fg_ativo === '1'">
                <textarea rows="7" class="form-control" :placeholder="dadosMsg.placeholder" maxlength="512" v-model="dadosMsg.resposta" :disabled="dadosMsg.fg_ativo !== '1'" style="resize: none"></textarea>
              </div>
              <div v-else>
                <textarea rows="7" class="form-control" v-model="dadosMsg.placeholder" disabled="true" style="resize: none"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal :opened="modalConta" preview="true" width="tiny" @fechar="modalConta = false">
      <auth-login-form
        title="Adicionar conta"
        subtitle="Informe seu usuário de acesso"
        submit-label="Continuar"
        :show-unknown-user-link="false"
        :show-recover-link="false"
        :allow-recovery-redirect="false"
        :can-submit="empresas.length < 3"
        blocked-message="No momento é possível adicionar no máximo 3 contas."
        :embedded="true"
        @authenticated="handleContaAdicionada"
      />
    </modal>

    <opcoes ref="opt" :fluxo="id_fluxo" :master="master" @atualizar="buscarOpcoesBot"/>
  </div>
</template>

<script>
import AuthLoginForm from "@/components/auth/AuthLoginForm";
import Modal from "../components/commons/Modal";
import ModalMenu from "../components/commons/ModalMenu";
import Loading from "../components/commons/Loading";
import TopBar from "@/components/commons/TopBar";
import Opcoes from "@/components/configs/Opcoes";
import Tooltip from "@/components/commons/Tooltip";

export default {
  name: 'ConfigBot',
  components: {AuthLoginForm, Tooltip, Opcoes, TopBar, Loading, Modal, ModalMenu},
  data() {
    return {
      token: localStorage.getItem('key'),
      menus: [
        { nome: 'Dados', active: true },
        { nome: 'Mensagens', active: true },
        { nome: 'Opções', active: true },
        { nome: 'Sistema', active: true },
      ],
      menu: 1,
      load: true,
      dados: {
        id_chatbot_config: '',
        id_empresa: '',
        icon_bot: '',
        nome_bot: '',
        atendimento: '',
        recuperador: '',
        msg_avaliacao: '',
        link_bot: '',
        log_error: '',
        id_fluxo: '1',
        atendimento_tempo: '',
        lebot_notificacao: '0',
        notifica_mktplace: '0',
        ignora_interacao: '0'
      },
      modo_alternativo: false,
      modo_beta: false,
      modo_teste: false,

      loadMsg: false,
      dadosMsg: null,
      perguntas: [
        {
          tipo: 1,
          titulo: 'Boas-vindas',
          descricao: 'Mensagem de saudação ao cliente.',
          placeholder: "{nome_cliente} que bom ver você por aqui! 😊",
        },
        {
          tipo: 2,
          titulo: 'Pedido em análise',
          descricao: 'Mensagem quando o cliente enviar o pedido mas ainda não foi aceito.',
          placeholder: 'Seu pedido foi recebido e está em análise! 😊\n\n👉 Fique tranquilo, vou te atualizando sobre cada etapa'
        },
        {
          tipo: 3,
          titulo: 'Pedido agendado',
          descricao: 'Mensagem quando o cliente enviar um pedido agendado.',
          placeholder: 'Seu pedido foi agendado com sucesso! 🤩\n\n⏰ Agendado para: {agendamento}'
        },
        {
          tipo: 4,
          titulo: 'Pedido aceito',
          descricao: 'Mensagem quando for aceito o pedido do cliente.',
          placeholder: 'Seu pedido foi aceito e já está em produção! 🤩\n\n⏰ Estimativa: {previsao}'
        },
        {
          tipo: 5,
          titulo: 'Pedido entrega',
          descricao: 'Mensagem quando o pedido for despachado para o cliente.',
          placeholder: "Hummmmm 😋\n\nSegura a fome aí {nome_cliente}, seu pedido já saiu para entrega! 🛵"
        },
        {
          tipo: 6,
          titulo: 'Pedido retirada',
          descricao: 'Mensagem para avisar que o pedido está pronto para ser retirado.',
          placeholder: "*Corre aê {nome_cliente}!* 🏃🏼 \n\n👉 Seu pedido já está pronto para ser retirado.\n\nEstamos te aguardando! 😊"
        },
        {
          tipo: 7,
          titulo: 'Pedido cancelado',
          descricao: 'Mensagem para avisar que o pedido foi cancelado.',
          placeholder: "Infelizmente seu pedido foi cancelado. 😢\n\nMotivo: {motivo}\n\n👉 Se preferir é só entrar em contato conosco que te explicamos melhor."
        },
        {
          tipo: 8,
          titulo: 'Callback',
          descricao: 'Mensagem caso não conseguir entender e for transferir para um atendente.',
          placeholder: "Lamento não conseguir te ajudar! Vou te transferir para um atendente ta bom?\n\nTempo de espera: {tempo_espera}"
        },
        {
          tipo: 9,
          titulo: 'Atendimento indisponível',
          descricao: 'Mensagem caso o atendimento humano estiver indisponível.',
          placeholder: "➡️ Este canal de atendimento está indisponível no momento.\n\nPara falar com um atendente, entre em contato pelo nosso Telefone ☎️\n\n{telefone_empresa}"
        },
        {
          tipo: 10,
          titulo: 'Mensagem Programa de Vantagens',
          descricao: 'Mensagem do programa de vantagens a ser enviada assim que o pedido for aceito.',
          placeholder: "Você pontuou! 🎉🥳\n\n🏆 Saldo atual: *{saldo}*\n\nPontue e troque seus pontos por benefícios exclusivos."
        },
        {
          tipo: 11,
          titulo: 'Mensagem de avaliação',
          descricao: 'Mensagem para o cliente avaliar o pedido.',
          placeholder: "{nome_cliente}, esperamos que tenha gostado do seu pedido! 😊\n\n🌟 Poderia nos contar o que achou?\n\nBasta clicar no link abaixo para deixar sua avaliação 👇\n\n{link}"
        },
        {
          tipo: 12,
          titulo: 'Mensagem recuperador de venda',
          descricao: 'Mensagem caso o cliente desistiu de finalizar o pedido.',
          placeholder: "Olá! 👋\nAinda não fez seu pedido? Não se preocupe, ainda dá tempo! 🤩\n\nBasta clicar no link abaixo:\n📲 {link}"
        }
      ],
      modalMsg: false,
      modalConta: false,
      id_fluxo: '1',
      opcoes: [],
      mensagens: []
    }
  },

  methods: {
    toggleConfigAlerta(campo) {
      const ativo = this.dados[campo] === '1';
      if (!ativo) {
        return;
      }

      const mensagens = {
        ignora_interacao: "O ideal é que o usuário envie uma mensagem primeiro para iniciar a interação. Sem esse contato prévio, há risco de o WhatsApp bloquear a conta.",
        notifica_mktplace: "Essa é uma configuração não recomendada. Se ativada, o envio de notificações para pedidos de marketplaces ficará por conta e risco do usuário, podendo causar bloqueio da conta no WhatsApp."
      };

      this.$swal({
        text: mensagens[campo],
        buttons: ["Cancelar", "Confirmar"],
        dangerMode: true
      }).then((result) => {
        if (!result) {
          this.dados[campo] = '0';
        }
      });
    },

    changeMenu(m) {
      this.menu = m;

      if (m === 3 && !this.opcoes.length) {
        this.buscarOpcoesBot();
      }
    },

    buscarConfigsBot() {
      this.$http.get('chatbot/config/' + this.token)
        .then(response => {
          this.load = false;
          this.dados = {
            ...this.dados,
            ...response.data
          };
          this.id_fluxo = this.dados.id_fluxo;

        }, res => {
          this.load = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
        })
    },

    enviarDados() {
      if (this.dados.atendimento === '1' && !this.dados.atendimento_tempo) {
        this.$swal("Informe quantos minutos para ser atendido.").then(() => {
          this.$helpers.focusElement('tempo');
        });
        return;
      }

      this.load = true;
      this.$http.post('chatbot/config/' + this.token, this.dados)
        .then(res => {
          this.$swal("Configurações editadas com sucesso.");
          this.buscarConfigsBot();

        }, res => {
          console.log(res);
          this.load = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
        });
    },

    selMensagem(dados) {
      this.dadosMsg = null;
      this.modalMsg = true;
      this.loadMsg = true;
      this.$emit('openModal');

      this.$http.get(`chatbot/mensagens/${this.token}/${dados.tipo}`)
        .then(response => {
          this.loadMsg = false;
          const data = response.data || {};
          this.dadosMsg = {
            resposta: data.resposta || '',
            titulo: dados.titulo,
            tipo: dados.tipo,
            descricao: dados.descricao,
            placeholder: dados.placeholder,
            fg_ativo: data.fg_ativo || '2'
          }

        }, res => {
          this.loadMsg = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
        });
    },

    salvarMensagem() {
      if (this.loadMsg) {
        return;
      }

      this.loadMsg = true;
      this.$http.post('chatbot/mensagens/' + this.token, this.dadosMsg)
        .then(res => {
          this.loadMsg = false;
          this.modalMsg = false;
          this.$swal("Mensagem editada com sucesso.");

        }, res => {
          console.log(res);
          this.loadMsg = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
        });
    },

    buscarOpcoesBot() {
      this.load = true;
      this.$http.get('chatbot/opcoes/' + this.token, { params: { id_fluxo: this.id_fluxo }})
        .then(response => {
          this.load = false;
          this.opcoes = response.data || [];

        }, res => {
          this.load = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
        });
    },

    selOpcao(id_opcao, importar) {
      if (!this.opcoes.length || importar) {
        this.$swal({
          text: "Será importado as opções para este fluxo, deseja continuar?",
          buttons: ["Cancelar", "Sim"],
          dangerMode: true
        }).then((result) => {
          if (result) {
            this.load = true;
            const dados = { importar: true, id_fluxo: this.id_fluxo }
            this.$http.post('chatbot/opcoes/' + this.token, dados)
              .then(res => {
                this.$swal("Fluxo importado com sucesso.");
                this.buscarOpcoesBot();

              }, res => {
                console.log(res);
                this.load = false;
                this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
              });
          }
        });

      } else {
        this.$refs.opt.openOpcao(id_opcao);
      }
    },

    removerOpcao(opcao) {
      this.$swal({
        text: "Deseja remover esta opção?",
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then((result) => {
        if (result) {
          this.load = true;
          const dados = { id_opcao: opcao.id_opcao, id_fluxo: opcao.id_fluxo, remover: true }
          this.$http.post('chatbot/opcoes/' + this.token, dados)
            .then(res => {
              this.$swal("Opção removida com sucesso.");
              this.buscarOpcoesBot();

            }, res => {
              console.log(res);
              this.load = false;
              this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
            });
        }
      });
    },

    toggleServer() {
      if (this.modo_teste) {
        this.$swal("Remova o Modo Teste para habilitar o modo alternativo!");
        return;
      }

      const modo = this.modo_alternativo ? "desativar" : "ativar";

      this.$swal({
        text: "Deseja " + modo + " o servidor alternativo?",
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then((result) => {
        if (result) {
          if (!this.modo_alternativo) {
            localStorage.setItem('base_server', this.server_alternativo);

          } else {
            localStorage.removeItem('base_server');
            sessionStorage.removeItem('base_server');
          }

          window.location.href = "/configs";
        }
      });
    },

    toggleServerTeste() {
      const modo = this.modo_teste ? "desativar" : "ativar";

      this.$swal({
        text: "Deseja " + modo + " o servidor de teste?",
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then((result) => {
        if (result) {
          if (!this.modo_teste) {
            localStorage.setItem('base_server', this.server_teste);

          } else {
            localStorage.removeItem('base_server');
            sessionStorage.removeItem('base_server');
          }

          this.logout(true);
        }
      });
    },

    toggleServerBeta() {
      const modo = this.modo_beta ? "desativar" : "ativar";

      this.$swal({
        text: "Deseja " + modo + " o servidor beta?",
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then((result) => {
        if (result) {
          if (!this.modo_beta) {
            localStorage.setItem('base_server', this.server_beta);

          } else {
            localStorage.removeItem('base_server');
            sessionStorage.removeItem('base_server');
          }

          window.location.href = "/";

          if (this.isElectron) {
            window.control.fechar({ reiniciar: true });
          }
        }
      });
    },

    confirmLogout() {
      this.$swal({
        text: this.empresas.length > 1 ? "Deseja sair de todas as contas do sistema?" : "Deseja sair do sistema?",
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then((result) => {
        if (result) {
          this.logout(false, true);
        }
      });
    },

    resetar() {
      this.$swal({
        text: "Deseja resetar o sistema?",
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then((result) => {
        if (result) {
          this.logout(true, true);
        }
      });
    },

    changeEmpresa() {
      this.load = true;
      this.token = localStorage.getItem('key');
      this.opcoes = [];
      this.buscarConfigsBot();
      this.changeMenu(this.menu);
    },

    handleContaAdicionada({ data }) {
      const key = data.token;

      if (this.empresas.find(e => e.key === key) || this.empresas.find(e => e.id_empresa === data.id_empresa)) {
        this.$swal('Você já está logado, faça o login em outra conta ou volte ao menu principal.');
        return;
      }

      const empresas = [...this.empresas, { key, token: '', isDefault: false }];
      localStorage.setItem('empresas', JSON.stringify(empresas));
      this.modalConta = false;
      window.location.href = "/configs";

      if (this.isElectron) {
        window.control.fechar({ reiniciar: true });
      }
    },

    removerEmpresa(e) {
      this.$swal({
        text: "Deseja sair desta conta?",
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then(res => {
        if (res) {
          const empresas = this.empresas.filter(el => el.key !== e.key);
          localStorage.setItem('empresas', JSON.stringify(empresas));
          window.location.href = "/configs";

          if (this.isElectron) {
            window.control.fechar({ reiniciar: true, resetar: true, wpp: e.wpp });
          }
        }
      })
    }
  },

  computed: {
    user() {
      return this.$store.state.dataUser
    },

    empresas() {
      return this.$store.state.empresas
    },

    master() {
      return this.$store.state.dataUser.master
    },

    version() {
      return this.$store.state.version
    }
  },

  mounted() {
    this.buscarConfigsBot();
  },

  created() {
    const url_alternativo = localStorage.getItem('base_server');

    if (url_alternativo) {
      if (url_alternativo === this.server_alternativo) {
        this.modo_alternativo = true;

      } else if (url_alternativo === this.server_teste) {
        this.modo_teste = true;

      } else if (url_alternativo === this.server_beta) {
        this.modo_beta = true;
      }
    }
  },
}
</script>
<style scoped>
@media (min-width: 768px) {
  .version {
    position: fixed;
    bottom: 0;
    left: 74px;
    font-size: 0.7em;
    width: calc(100% - 74px);
    background-color: #fff;
    padding: 2px 0;
    border-top: 1px solid #dee2e6;
    z-index: 1;
  }
}
</style>
